import React from 'react';
import { SalesPageDark } from './pages/SalesPageDark';
export function App() {
  return <SalesPageDark data-id="element-0" />;
}